<template>
  <v-form ref="ACCIDENT_TRAVAIL" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="ACCIDENT_TRAVAIL">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <accident-travail-type v-if="isDisplayed('TYPE')"
                               ref="TYPE"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=type
                               @status=statusType
                               :required="isRequired('TYPE')"
                               :contextId=accidentTravail.id
                               :readOnly="readOnly('TYPE')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </accident-travail-type>
        <accident-travail-code-risque v-if="isDisplayed('CODE_RISQUE')"
                                      ref="CODE_RISQUE"
                                      :theme="theme"
                                      :showMissing="showMissing"
                                      v-model:value=codeRisque
                                      @status=statusCodeRisque
                                      :over-ride-placeholder=placeholderCodeRisque
                                      :required="isRequired('CODE_RISQUE')"
                                      :contextId=accidentTravail.id
                                      :readOnly="readOnly('CODE_RISQUE')"
                                      :objType=objType
                                      :fiche=fiche
                                      :sectionName="sectionName">
        </accident-travail-code-risque>
        <accident-travail-taux-patronal v-if="isDisplayed('TAUX_PATRONAL')"
                                        ref="TAUX_PATRONAL"
                                        :theme="theme"
                                        :showMissing="showMissing"
                                        v-model:value=tauxPatronal
                                        @status=statusTauxPatronal
                                        :required="isRequired('TAUX_PATRONAL')"
                                        :contextId=accidentTravail.id
                                        :readOnly="readOnly('TAUX_PATRONAL')"
                                        :objType=objType
                                        :fiche=fiche
                                        :sectionName="sectionName">
        </accident-travail-taux-patronal>
        <accident-travail-date-effet v-if="isDisplayed('DATE_EFFET')"
                                     ref="DATE_EFFET"
                                     :theme="theme"
                                     :showMissing="showMissing"
                                     v-model:value=dateEffet
                                     @status=statusDateEffet
                                     :periods='periodDateEffet'
                                     :required="isRequired('DATE_EFFET')"
                                     :contextId=accidentTravail.id
                                     :readOnly="readOnly('DATE_EFFET')"
                                     :objType=objType
                                     :fiche=fiche
                                     :sectionName="sectionName">
        </accident-travail-date-effet>
        <accident-travail-source v-if="isDisplayed('SOURCE')"
                                 ref="SOURCE"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=source
                                 @status=statusSource
                                 :required="isRequired('SOURCE')"
                                 :contextId=accidentTravail.id
                                 :readOnly="readOnly('SOURCE')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </accident-travail-source>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudAccidentTravail from '@/generated/cruds/CrudAccidentTravail';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudAccidentTravail,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.ACCIDENT_TRAVAIL,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderCodeRisque: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.ACCIDENT_TRAVAIL); },

      fields (): string[] {
        return ['TYPE', 'CODE_RISQUE', 'TAUX_PATRONAL', 'DATE_EFFET', 'SOURCE'];
      },

      extraButtons (): Button[] {
        return [];
      },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editAccidentTravail.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("TYPE", false);
          this.readOnlyMap.set("CODE_RISQUE", false);
          this.readOnlyMap.set("TAUX_PATRONAL", false);
          this.readOnlyMap.set("DATE_EFFET", false);
          this.readOnlyMap.set("SOURCE", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("TYPE", true);
          this.displayMap.set("CODE_RISQUE", true);
          this.displayMap.set("TAUX_PATRONAL", true);
          this.displayMap.set("DATE_EFFET", true);
          this.displayMap.set("SOURCE", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("TYPE", true);
          this.requiredMap.set("CODE_RISQUE", true);
          this.requiredMap.set("TAUX_PATRONAL", true);
          this.requiredMap.set("DATE_EFFET", true);
          this.requiredMap.set("SOURCE", true);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoTravail' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
